'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _dragOffset = require('./dragOffset');

var _dragOffset2 = _interopRequireDefault(_dragOffset);

var _dragOperation = require('./dragOperation');

var _dragOperation2 = _interopRequireDefault(_dragOperation);

var _refCount = require('./refCount');

var _refCount2 = _interopRequireDefault(_refCount);

var _dirtyHandlerIds = require('./dirtyHandlerIds');

var _dirtyHandlerIds2 = _interopRequireDefault(_dirtyHandlerIds);

var _stateId = require('./stateId');

var _stateId2 = _interopRequireDefault(_stateId);

exports['default'] = function (state, action) {
  if (state === undefined) state = {};

  return {
    dirtyHandlerIds: _dirtyHandlerIds2['default'](state.dirtyHandlerIds, action, state.dragOperation),
    dragOffset: _dragOffset2['default'](state.dragOffset, action),
    refCount: _refCount2['default'](state.refCount, action),
    dragOperation: _dragOperation2['default'](state.dragOperation, action),
    stateId: _stateId2['default'](state.stateId)
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/reducers/index.js
// module id = 260
// module chunks = 0